import { onError } from '@apollo/client/link/error';
import { removeAuth } from 'utils/auth';
import { getMessageApi } from 'utils/messageHolder';
import { t } from '../i18n';

export const errorLink = onError(({graphQLErrors, networkError}) => {
    const msg = getMessageApi();

    if (graphQLErrors) {
        for (const err of graphQLErrors) {
            const code = err.extensions?.code;
            const messageKey = err.extensions?.messageKey;

            const translatedMessage: string = t(messageKey as string) as string;

            const currentPath = window.location.pathname;
            switch(code) {
                case 'UNAUTHORIZED':
                    console.error('UNAUTHORIZED, path:', currentPath, 'messageKey:', messageKey);
                    if (currentPath.includes('/login')) {
                        break;
                    }
                    msg?.error(translatedMessage);
                    const timeout = setTimeout(() => {
                        removeAuth();
                        window.location.href = '/ClientCenter/login';
                        clearTimeout(timeout);
                    }, 3000);
                    break;

                /*
                 * 与 portalRestClient.handleErrorResponse 的 PERMISSION 分支保持一致：优先展示 messageKey 的译文。
                 * 不能落到 default，那里以 err.message 优先，会把服务端原始串
                 * "[PERMISSION] errors.auth.permissionDenied permissionCode=xxx" 直接弹给用户。
                 */
                case 'PERMISSION':
                    console.error('PERMISSION, path:', currentPath, 'messageKey:', messageKey, 'message:', err.message);
                    msg?.error(translatedMessage || t('errors.auth.permissionDenied'));
                    break;

                case 'VALIDATION_ERROR':
                    console.error('VALIDATION_ERROR, path:', currentPath, 'messageKey:', messageKey, 'message:', err.message);
                    msg?.error(translatedMessage || err.message || 'Validation error');
                    break;

                case 'BUSINESS_ERROR':
                    console.error('BUSINESS_ERROR, path:', currentPath, 'messageKey:', messageKey, 'message:', err.extensions?.message || err.message);
                    msg?.error(translatedMessage || err.message || 'Business error');
                    break;

                /*
                 * 与上面 PERMISSION 分支同理：不能以 err.message 优先。服务端 INTERNAL_ERROR 的 message
                 * 是给运维看的技术串（如 "getExternalOrderTracking 调用异常"），既不国际化也会暴露内部接口名，
                 * 只能进 console。非 SwiftXException 时服务端不下发 messageKey，此时走通用兜底文案。
                 */
                case 'INTERNAL_ERROR':
                default:
                    console.error('SYSTEM_ERROR, path:', currentPath, 'messageKey:', messageKey, 'message:', err.message);
                    msg?.error(translatedMessage || t('errors.system'));
                    break;
            }
        }
    }

    if (networkError) {
        msg?.error(t('errors.network'));
    }
});
